import { useEffect } from "react";
import { registerAdsPageView, AdTemplatesEnum } from "utils/ads";
import { useQuery, gql, withData, UrqlPageType } from "utils/urql";
import { trackHomepagePageView } from "utils/analytics";
import { HomepageQuery } from "types/api";
import HomepageLayout from "components/homepage/HomepageLayout";

const HOMEPAGE_QUERY = gql`
  query HomepageQuery {
    breakingNews {
      homepageEnabled
    }
  }
`;

const Homepage: UrqlPageType = () => {
  const [{ data }] = useQuery<HomepageQuery>({ query: HOMEPAGE_QUERY });

  useEffect(() => {
    trackHomepagePageView();

    registerAdsPageView({
      lazy_load: 1,
      channel: "homepage",
      template: AdTemplatesEnum.homepage,
      globalTargeting: {
        title: "The Atlantic",
      },
    });
  }, []);

  return <HomepageLayout breakingNews={data?.breakingNews} />;
};

Homepage.getInitialProps = async ({ res }) => {
  if (res) {
    // Set Surrogate-Key header for Fastly cache purging
    res.setHeader("Surrogate-Key", "homepage-b1");
  }
};

export default withData(Homepage);
